import config from "config/config";
export async function registerUser(
  oldPolicyId,
  contractId,
  firstName,
  lastName,
  identityNumber,
  postalCode,
  MobileNumber,
  paperlessProcess,
  notificationPreference,
  emailId,
  userName,
  password,
  roleId,
  userSecurityQA,
  insuredDoB,
  updateEmailFlag,
  updateEmailOption,
  ownerType,
  taxType
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify({
      AlternateId: oldPolicyId,
      ContractId: contractId,
      FirstName: firstName,
      LastName: lastName,
      IdentityNumber: identityNumber,
      PostalCode: postalCode,
      MobileNumber: MobileNumber,
      PaperlessProcess: paperlessProcess,
      NotificationPreference: notificationPreference,
      EmailId: emailId,
      UserName: userName,
      Password: password,
      RoleId: roleId,
      UserSecurityQA: userSecurityQA,
      InsuredDoB: insuredDoB,
      UpdateEmail: updateEmailFlag,
      UpdateEmailOptions: updateEmailOption,
      OwnerType: ownerType,
      taxType: taxType,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/register",
    options
  );

  return response;
}
